// Import React and Hooks
import React from 'react'
// Import Components
import BackgroundSide from './BackgroundSide'
import FloatImg from '../ui/FloatImg'



// Background Props
interface backgroundProp {
  type?:string,
  additionalClass?:string
}

const Background = ( { type = 'default', additionalClass }:backgroundProp ) => {



  // Functions
  function renderBg( type:string ) {
    switch (type) {
      case 'side':
        return <BackgroundSide />
      case 'both-side':
        return <>
          <BackgroundSide />
          <BackgroundSide />
        </>
      case 'square':
        return <BackgroundSide
          type="square" />
      case 'both-square':
        return <>
          <BackgroundSide
            type="square" />
          <BackgroundSide
            type="square" />
        </>
      case 'landing':
        return <>
         <FloatImg
            additionalClass="flowerBgLanding0"
            speed={ 0.012 }
            revert={ true }
            alt="Flor"
            src={`${window.assetsURl}/imgs/shapes/colibries-05-Rdy-4+(2).png`} />
          <FloatImg
            additionalClass="flowerBgLanding1"
            speed={ 0.012 }
            revert={ true }
            alt="Flor"
            src={`${window.assetsURl}/imgs/shapes/flor-new.png`} />
          <FloatImg
            additionalClass="flowerBgLanding2"
            speed={ 0.008 }
            alt="Flor"
            src={`${window.assetsURl}/imgs/shapes/flor-new.png`} />
        </>
      default:
        return <p> ERROR </p>
    }
  }



  return (
    <section className={`background ${ additionalClass ? additionalClass : ''}`} >
      { renderBg( type ) }
    </section>
  )
}



export default Background
